import React from 'react';
import { motion } from 'framer-motion';
import { useI18n } from '../lib/i18n';
import { Activity, Minimize2, RefreshCw, Network } from 'lucide-react';
export function WhatIsCLVN() {
  const {
    t
  } = useI18n();
  const chips = [{
    icon: <Activity size={14} data-id="element-249" />,
    label: t('whatIs.chips.latencia')
  }, {
    icon: <Minimize2 size={14} data-id="element-250" />,
    label: t('whatIs.chips.reversibilidad')
  }, {
    icon: <RefreshCw size={14} data-id="element-251" />,
    label: t('whatIs.chips.resonancia')
  }, {
    icon: <Network size={14} data-id="element-252" />,
    label: t('whatIs.chips.sistemas')
  }];
  return <section className="py-32 relative border-t border-black/[0.06] bg-[#FAFAFA]" data-id="element-253">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-254">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-255">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-256">
            <h2 className="font-display text-4xl md:text-5xl mb-8 text-[#0A0A0F]" data-id="element-257">
              {t('whatIs.title')}
            </h2>
            <div className="space-y-6 text-lg text-[#3A3A45] font-light leading-relaxed" data-id="element-258">
              <p data-id="element-259">{t('whatIs.p1')}</p>
              <p data-id="element-260">{t('whatIs.p2')}</p>
            </div>

            <div className="mt-12 flex flex-wrap gap-3" data-id="element-261">
              {chips.map((chip, i) => <div key={i} className="flex items-center gap-2 px-4 py-2 rounded-full border border-black/[0.08] bg-white text-sm text-[#2A2A35] shadow-sm" data-id="element-262">
                  <span className="text-violet-electric" data-id="element-263">{chip.icon}</span>
                  {chip.label}
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-264">
            <div className="absolute inset-0 bg-violet-200/40 blur-[100px] rounded-full pointer-events-none" data-id="element-265" />

            <div className="relative bg-white border border-black/[0.06] shadow-sm p-12 md:p-16 rounded-2xl flex flex-col items-center justify-center text-center" data-id="element-266">
              <div className="font-mono text-4xl md:text-6xl text-[#0A0A0F] mb-8 tracking-tight" data-id="element-267">
                λ(a) = a · 10
                <sup className="text-2xl md:text-4xl text-violet-electric" data-id="element-268">
                  −100
                </sup>
              </div>
              <div className="h-px w-16 bg-black/[0.15] mb-8" data-id="element-269" />
              <p className="text-sm text-[#4A4A55] font-mono uppercase tracking-widest max-w-xs leading-relaxed" data-id="element-270">
                {t('whatIs.equationCaption')}
              </p>
            </div>

            {/* ─── Blockchain Registration Credential ───────────────── */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="relative mt-6 flex items-center gap-4 p-4 bg-white border border-black/[0.06] rounded-xl shadow-sm" data-id="element-271">
              <div className="flex-shrink-0 w-16 h-16 rounded-lg bg-[#FAFAFA] border border-black/[0.06] flex items-center justify-center overflow-hidden" data-id="element-272">
                <img src="https://cdn.magicpatterns.com/uploads/v8wYa1nXuUy5u1YV6say9L/favicon.png.png" alt="CLVN-LRR™ blockchain registration" className="w-full h-full object-contain" data-id="element-273" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-274">
                <div className="flex items-center gap-2 mb-1" data-id="element-275">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" data-id="element-276" />
                  <span className="text-[10px] font-mono uppercase tracking-widest text-emerald-700" data-id="element-277">
                    {t('blockchain.registered')} · {t('blockchain.date')}
                  </span>
                </div>
                <p className="text-sm text-[#0A0A0F] font-medium" data-id="element-278">
                  {t('blockchain.label')}
                </p>
                <p className="text-[10px] font-mono text-[#8A8A95] truncate mt-1" data-id="element-279">
                  bafybeielws52jcgrp3xrerersbpmizj5khfuy364srlwajdtyxshslajpqu
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}